webpackJsonp([1],{

/***/ "+eDH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/AuU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2YVP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/WhtBrd-bars.f42abf3.png";

/***/ }),

/***/ "6A3X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9de3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9ink":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-awesome/components/Icon.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ var Icon = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d0258de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-awesome/components/Icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-awesome/components/Icon.vue
function injectStyle (ssrContext) {
  __webpack_require__("/AuU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Icon,
  components_Icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_awesome_components_Icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IoiM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/kDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var kDialog = ({
  props: {
    transition: String,
    transEnter: String,
    transLeave: String,
    showModal: Boolean,
    typeClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3f5d44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kDialog.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition,"enter-active-class":_vm.transEnter,"leave-active-class":_vm.transLeave}},[(_vm.showModal)?_c('div',{class:[{'modal-container': true}, _vm.typeClass]},[(this.$slots.header)?_c('div',{staticClass:"modal-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),(this.$slots.body)?_c('div',{staticClass:"modal-body"},[_vm._t("body")],2):_vm._e(),_vm._v(" "),(this.$slots.footer)?_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_kDialog = (esExports);
// CONCATENATED MODULE: ./src/components/kDialog.vue
function injectStyle (ssrContext) {
  __webpack_require__("9de3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e3f5d44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  kDialog,
  components_kDialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_kDialog = (Component.exports);

// EXTERNAL MODULE: ./node_modules/firebase/index.js
var firebase = __webpack_require__("Sazm");
var firebase_default = /*#__PURE__*/__webpack_require__.n(firebase);

// EXTERNAL MODULE: ./node_modules/date-fns/format/index.js
var format = __webpack_require__("Eoz/");
var format_default = /*#__PURE__*/__webpack_require__.n(format);

// EXTERNAL MODULE: ./node_modules/unix-timestamp/lib/timestamp.js
var timestamp = __webpack_require__("4ndX");
var timestamp_default = /*#__PURE__*/__webpack_require__.n(timestamp);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/toolbar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* Im useing route Meta tags to specify if the back button should 
be shown or if the the toolbaar should be shown at all. */






/* harmony default export */ var toolbar = ({

  name: 'toolbar',
  components: {
    kDialog: src_components_kDialog
  },
  props: {
    ver: {
      type: String
      /*
      showback: {
        type: Boolean,
        default: true
      }
      */
    } },
  data: function data() {
    return {
      title: 'WhtBrd',
      format: format_default.a,
      timestamp: timestamp_default.a,
      displayMenu: false,
      displayCalendar: false,
      selectedDay: "",
      displayDrawer: false
    };
  },

  computed: {
    calAttrs: function calAttrs() {
      return this.$store.getters.workoutDates.map(function (workout) {
        return {
          key: workout.id,
          dot: workout.type == 'metcon' ? { backgroundColor: '#007bff' } : { backgroundColor: '#6c757d' },
          dates: workout.date,
          customData: workout
        };
      });
    },
    showBack: function showBack() {
      if (this.$route.meta.showBack === undefined) {
        return true;
      } else {
        return this.$route.meta.showBack;
      }
    },
    isAdmin: function isAdmin() {
      return this.$store.state.user.admin;
    },
    showMenuBtn: function showMenuBtn() {
      if (this.$route.name == 'home') {
        return true;
      } else {
        return false;
      }
    },
    showToolbar: function showToolbar() {
      if (this.$route.meta.showToolbar === undefined) {
        return true;
      } else {
        return this.$route.meta.showToolbar;
      }
    },
    showCalendar: function showCalendar() {
      if (this.$route.meta.showCalendar === true) {
        return true;
      } else {
        return false;
      }
    }
    /*
    workouts: function() {
      return this.$store.state.workouts
    }
    */
  },
  watch: {
    workouts: function workouts() {
      this.calAttrs[1].dates = this.$store.getters.workoutDates.map(function (date) {
        return date.date;
      });
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    dayClicked: function dayClicked(day) {
      this.selectedDay = day;
      this.displayCalendar = false;
      if (this.selectedDay.attributes.length < 2) {
        //route to selected workout
        this.$router.push({ name: 'workout', params: { id: this.selectedDay.attributes[0].customData.id } });
      } else {
        //ask which workout they wanted...
        this.drawerDate = timestamp_default.a.toDate(this.selectedDay.dateTime);
        this.displayDrawer = true;
      }
      //
    },

    goToWorkout: function goToWorkout(id) {
      this.displayDrawer = false;
      this.$router.push({ name: 'workout', params: { id: id } });
    },
    goToProfile: function goToProfile() {
      this.$router.push({ path: '/profile' });
      this.displayMenu = false;
    },
    goToAdmin: function goToAdmin() {
      this.$router.push({ path: '/admin' });
      this.displayMenu = false;
    },
    logOut: function logOut() {
      var _this = this;

      firebase_default.a.auth().signOut().then(function () {
        _this.$store.commit('resetStore');
        _this.$router.replace('login');
      });
    },
    displaySearch: function displaySearch() {
      this.$router.push('search');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-175bc29b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toolbar.vue
var toolbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showToolbar)?_c('div',[_c('nav',{staticClass:"navbar fixed-top bg-white"},[_c('form',{staticClass:"form-inline"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBack),expression:"showBack"}],staticClass:"btn btn-sm align-middle btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.goBack($event)}}},[_c('icon',{attrs:{"name":"chevron-left"}}),_vm._v(" Back\n      ")],1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMenuBtn),expression:"showMenuBtn"}],staticClass:"btn btn-sm align-middle btn-outline-dark",on:{"click":function($event){$event.preventDefault();_vm.displayMenu = true}}},[_c('icon',{attrs:{"name":"bars"}})],1)]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('form',{staticClass:"form-inline"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCalendar),expression:"showCalendar"}],staticClass:"btn btn-sm align-middle btn-outline-dark",on:{"click":function($event){$event.preventDefault();_vm.displayCalendar = true}}},[_c('icon',{attrs:{"name":"calendar"}})],1),_vm._v(" "),_c('button',{staticClass:"btn btn-sm align-middle btn-outline-dark ml-2",on:{"click":function($event){$event.preventDefault();_vm.displaySearch($event)}}},[_c('icon',{attrs:{"name":"search"}})],1)])]),_vm._v(" "),_c('kDialog',{attrs:{"showModal":_vm.displayMenu,"typeClass":"menu","transition":"slide","transEnter":"slideInLeft","transLeave":"slideOutLeft"}},[_c('div',{staticClass:"headerSlot",attrs:{"slot":"header"},slot:"header"},[_c('small',[_vm._v("App Ver: "+_vm._s(_vm.ver))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-light closeBtn",on:{"click":function($event){_vm.displayMenu = false}}},[_c('icon',{attrs:{"name":"times"}})],1)]),_vm._v(" "),_c('div',{staticClass:"centerBody",attrs:{"slot":"body"},slot:"body"},[_c('ul',{staticClass:"list-group menu"},[_c('li',{staticClass:"list-group-item menuItem mt-3"},[_c('icon',{attrs:{"name":"envelope-o"}}),_vm._v(" Messages")],1),_vm._v(" "),_c('li',{staticClass:"list-group-item menuItem"},[_c('icon',{attrs:{"name":"dashboard"}}),_vm._v(" 1 Rep Max Lifts")],1),_vm._v(" "),_c('li',{staticClass:"list-group-item menuItem"},[_c('icon',{attrs:{"name":"star"}}),_vm._v(" Named/Open Wods")],1),_vm._v(" "),_c('li',{staticClass:"list-group-item menuItem",on:{"click":_vm.goToProfile}},[_c('icon',{attrs:{"name":"user"}}),_vm._v(" Profile")],1),_vm._v(" "),_c('li',{staticClass:"list-group-item menuItem"},[_c('icon',{attrs:{"name":"gear"}}),_vm._v(" Settings")],1),_vm._v(" "),(_vm.isAdmin)?_c('li',{staticClass:"list-group-item menuItem",on:{"click":_vm.goToAdmin}},[_c('icon',{attrs:{"name":"gear"}}),_vm._v(" Admin")],1):_vm._e()])])]),_vm._v(" "),_c('kDialog',{attrs:{"showModal":_vm.displayCalendar,"typeClass":"dropDown","transition":"slide","transEnter":"slideInDown","transLeave":"slideOutUp"}},[_c('div',{staticClass:"centerBody",attrs:{"slot":"body"},slot:"body"},[_c('v-calendar',{attrs:{"attributes":_vm.calAttrs,"is-expanded":""},on:{"dayclick":_vm.dayClicked}})],1),_vm._v(" "),_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-block btn-outline-light closeBtn",on:{"click":function($event){_vm.displayCalendar = false}}},[_c('icon',{attrs:{"name":"chevron-up"}}),_vm._v(" Close Calendar\n      ")],1)])]),_vm._v(" "),_c('kDialog',{attrs:{"showModal":_vm.displayDrawer,"typeClass":"drawer","transition":"slide","transEnter":"slideInUp","transLeave":"slideOutDown"}},[_c('div',{staticClass:"centerBody",attrs:{"slot":"body"},slot:"body"},[_c('h4',[_vm._v("Which Workout on "+_vm._s(_vm.format(_vm.selectedDay.date, 'MMM Do'))+"?")]),_vm._v(" "),_vm._l((_vm.selectedDay.attributes),function(workout){return _c('div',{key:workout.customData.id,staticClass:"btn btn-block btn-light workoutBtn",on:{"click":function($event){_vm.goToWorkout(workout.customData.id)}}},[_c('span',{staticClass:"badge badge-pill",class:[workout.customData.type == 'metcon' ? 'badge-primary' : workout.customData.type == 'lift' ? 'badge-secondary' :  'badge-info']},[_vm._v(_vm._s(workout.customData.type))]),_vm._v("\n        "+_vm._s(workout.customData.desc)+"\n     ")])})],2),_vm._v(" "),_c('div',{staticClass:"footer",attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-block btn-outline-light closeBtn",on:{"click":function($event){_vm.displayDrawer = false}}},[_c('icon',{attrs:{"name":"times-circle"}}),_vm._v(" Cancel\n      ")],1)])])],1):_vm._e()}
var toolbar_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"navbar-text nav-text navbar-center mt-2"},[_c('img',{staticClass:"toolbar-logo",attrs:{"src":__webpack_require__("UkAe")}})])}]
var toolbar_esExports = { render: toolbar_render, staticRenderFns: toolbar_staticRenderFns }
/* harmony default export */ var components_toolbar = (toolbar_esExports);
// CONCATENATED MODULE: ./src/components/toolbar.vue
function toolbar_injectStyle (ssrContext) {
  __webpack_require__("TAvA")
}
var toolbar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var toolbar___vue_template_functional__ = false
/* styles */
var toolbar___vue_styles__ = toolbar_injectStyle
/* scopeId */
var toolbar___vue_scopeId__ = "data-v-175bc29b"
/* moduleIdentifier (server only) */
var toolbar___vue_module_identifier__ = null
var toolbar_Component = toolbar_normalizeComponent(
  toolbar,
  components_toolbar,
  toolbar___vue_template_functional__,
  toolbar___vue_styles__,
  toolbar___vue_scopeId__,
  toolbar___vue_module_identifier__
)

/* harmony default export */ var src_components_toolbar = (toolbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Toolbar: src_components_toolbar
  },
  data: function data() {
    return {
      showBack: false,
      appVer: this.$appVer
    };
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f096fd3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('toolbar',{attrs:{"ver":_vm.appVer}}),_vm._v(" "),_c('router-view',{staticClass:"view"}),_vm._v(" "),_c('notifications',{attrs:{"group":"note","width":"100%","position":"top center","classes":"whtBrd-style"}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("+eDH")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vue-avatar/dist/vue-avatar.min.js
var vue_avatar_min = __webpack_require__("Y50r");
var vue_avatar_min_default = /*#__PURE__*/__webpack_require__.n(vue_avatar_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import firebase from 'firebase'



//import Workout from '@/workoutData.js'

/* harmony default export */ var home = ({
  name: 'home',
  components: {
    Avatar: vue_avatar_min_default.a
  },
  data: function data() {
    return {
      displayMenu: false,
      msg: 'Welcome to WhtBrd',
      format: format_default.a,
      transitionName: ""
    };
  },

  computed: {
    badgeClass: function badgeClass() {
      if (type = 'metcon') {
        return 'badge-primary';
      } else if (type = 'lift') {
        return 'badge-secondary';
      } else {
        return 'badge-light';
      }
    },
    allTimeScore: function allTimeScore() {
      return this.$store.getters.score;
    },
    monthScore: function monthScore() {
      return this.$store.getters.scoreThisMonth;
    },
    workouts: function workouts() {
      return this.$store.state.workouts;
    },
    authUser: function authUser() {
      return this.$store.state.authUser;
    },
    user: function user() {
      return this.$store.state.user;
    },

    totalWorkouts: function totalWorkouts() {
      return this.$store.getters.totalWorkouts;
    },
    monthWorkouts: function monthWorkouts() {
      return this.$store.getters.workoutsThisMonth;
    },

    noWorkouts: function noWorkouts() {
      return this.workouts.length == 0;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      //const toDepth = to.path.split('/').length
      var fromPath = from.path.split('/');
      console.log(fromPath);
      if (from.path = '/workout') {
        this.transitionName = slideLeft;
      }
    }
  },
  created: function created() {
    //this.$store.commit('setWorkouts')
  },

  methods: {
    goToWorkout: function goToWorkout(id) {
      //console.log(id)
      this.$router.push({ name: 'workout', params: { id: id } });
    },
    goToNewWorkout: function goToNewWorkout() {
      this.$router.push({ name: 'workout', params: { id: 0 } });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa602f1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
var home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideLeft"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('avatar',{attrs:{"username":_vm.user.displayName,"size":60,"backgroundColor":_vm.user.bgColor}})],1),_vm._v(" "),_c('div',{staticClass:"col-9"},[_c('h5',{staticClass:"mb-0"},[_vm._v("Welcome:")]),_vm._v(" "),_c('h3',{staticClass:"mt-1"},[_vm._v(_vm._s(_vm.user.displayName))])])]),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-sm btn-outline-primary",staticStyle:{"width":"49%"}},[_vm._v("\n            Total Workouts: "+_vm._s(_vm.totalWorkouts)+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-outline-info",staticStyle:{"width":"49%"}},[_vm._v("\n            This Month: "+_vm._s(_vm.monthWorkouts)+"\n          ")])])])])]),_vm._v(" "),(!_vm.noWorkouts)?_c('ul',{staticClass:"list-group mt-2"},_vm._l((_vm.workouts),function(workout){return _c('li',{key:workout.id,staticClass:"list-group-item",on:{"click":function($event){$event.preventDefault();_vm.goToWorkout(workout.id)}}},[(workout.pr)?_c('icon',{staticClass:"text-warning",attrs:{"name":"star"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge badge-pill",class:[workout.workoutType == 'metcon' ? 'badge-primary' : workout.workoutType == 'lift' ? 'badge-secondary' :  'badge-info']},[_vm._v(_vm._s(workout.workoutType))]),_vm._v(" \n        "+_vm._s(_vm.format(workout.date, 'MM/DD/YYYY'))+"\n        "),(workout.liftType)?_c('div',{staticClass:"workoutDesc"},[_vm._v("Lift: "+_vm._s(workout.liftType)+" - "+_vm._s(workout.description))]):(workout.isNamedWod)?_c('div',{staticClass:"workoutDesc"},[_vm._v("\""+_vm._s(workout.namedWod.name)+"\" - "+_vm._s(workout.namedWod.description))]):_c('div',{staticClass:"workoutDesc"},[_vm._v(_vm._s(workout.description))]),_vm._v(" "),_c('div',{staticClass:"workoutResult"},[_c('strong',[_vm._v("Result:")]),_vm._v(" "+_vm._s(workout.result)+" "),(workout.rx)?_c('span',{staticClass:"badge badge-pill badge-dark"},[_vm._v("Rx")]):_vm._e()])],1)})):_vm._e(),_vm._v(" "),(_vm.noWorkouts)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v("Welcome to WhtBrd")]),_vm._v(" "),_c('p',{staticClass:"card-text"}),_c('h5',[_vm._v("Get Started")]),_vm._v("\n        Just want a simple app to keep track of your workouts? You've come to the write place! \n        Add you first workout by clicking the big '+' below.\n        "),_c('h5',{staticClass:"mt-2"},[_vm._v("Update Your Profile")]),_vm._v("\n        Click on the Menu button (top left) then 'Profile' to change your avatar and add additional details to yuor account.\n        "),_c('h2',[_vm._v("Thank You!")])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"fabBtn",on:{"click":_vm.goToNewWorkout}},[_c('icon',{attrs:{"name":"plus"}})],1)])])}
var home_staticRenderFns = []
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var components_home = (home_esExports);
// CONCATENATED MODULE: ./src/components/home.vue
function home_injectStyle (ssrContext) {
  __webpack_require__("cGVt")
}
var home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var home___vue_template_functional__ = false
/* styles */
var home___vue_styles__ = home_injectStyle
/* scopeId */
var home___vue_scopeId__ = "data-v-0fa602f1"
/* moduleIdentifier (server only) */
var home___vue_module_identifier__ = null
var home_Component = home_normalizeComponent(
  home,
  components_home,
  home___vue_template_functional__,
  home___vue_styles__,
  home___vue_scopeId__,
  home___vue_module_identifier__
)

/* harmony default export */ var src_components_home = (home_Component.exports);

// EXTERNAL MODULE: ./node_modules/firebase/firestore/index.js
var firestore = __webpack_require__("3VHS");
var firestore_default = /*#__PURE__*/__webpack_require__.n(firestore);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







//import Workout from '@/workoutData.js'

/* harmony default export */ var profile = ({
  name: 'profile',
  components: {
    Toolbar: src_components_toolbar,
    Avatar: vue_avatar_min_default.a
  },
  computed: {
    user: function user() {
      return this.$store.state.user;
    }
  },
  data: function data() {
    return {
      msg: 'This is the user profile page',
      bgColor: "",
      colorList: [{
        class: '--blue',
        bgColor: '#007bff'
      }, {
        class: '--indigo',
        bgColor: '#6610f2'
      }, {
        class: '--pink',
        bgColor: '#e83e8c'
      }, {
        class: '--red',
        bgColor: '#dc3545'
      }, {
        class: '--orange',
        bgColor: '#fd7e14'
      }, {
        class: '--teal',
        bgColor: '#20c997'
      }, {
        class: '--cyan',
        bgColor: '#17a2b8'
      }, {
        class: '--grey',
        bgColor: '#868e96'
      }, {
        class: '--white',
        bgColor: '#fff'
      }, {
        class: '--black',
        bgColor: '#111'
      }]
    };
  },

  methods: {
    logOut: function logOut() {
      var _this = this;

      firebase_default.a.auth().signOut().then(function () {
        _this.$store.commit('resetStore');
        _this.$router.replace('login');
      });
    },

    chooseColor: function chooseColor(color) {
      this.$store.commit('setBgColor', color);
      console.log('Color Picked: ' + color);
    },
    updateProfile: function updateProfile() {
      this.$store.commit('updateUser');
      this.$router.push('home');
      this.$notify({
        group: 'note',
        text: 'Profile Updated',
        type: 'save'
      });
    }
    /*
    uploadWorkouts () {
      this.$store.commit('uploadNamedWorkouts')
    },
    seedWorkouts() {
      let seed = 0
      let userDocRef = this.$store.state.db.collection('users').doc(this.$store.getters.userId)
      
       this.workouts.forEach(workout => {
        userDocRef.collection('workouts').add({
          'date': new Date(workout.date),
          'workoutType': workout.workoutType,
          'description': workout.description,
          'tags': workout.tags,
          'result': workout.result,
          'notes': workout.Notes,
          'Weather': workout.Weather 
        })
        seed++
        if(this.workouts.length == seed) {
          console.log(`Added ${seed} records.`)
        }
        
      })
      
    }*/
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb9b9b9c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile.vue
var profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h4',[_vm._v("User Profile")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"}),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('avatar',{attrs:{"username":_vm.user.displayName,"size":55,"backgroundColor":_vm.user.bgColor}})],1),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"col-12 mt-2"},_vm._l((_vm.colorList),function(color){return _c('a',{key:color.bgColor,staticClass:"colorBox m-1",class:color.class,on:{"click":function($event){$event.preventDefault();_vm.chooseColor(color.bgColor)}}},[_vm._v(" ")])}))]),_vm._v(" "),_c('form',{staticClass:"form mt-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Display Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.displayName),expression:"user.displayName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Display Name"},domProps:{"value":(_vm.user.displayName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "displayName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Box Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.boxName),expression:"user.boxName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Box Name"},domProps:{"value":(_vm.user.boxName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "boxName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Box City, State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.boxCityState),expression:"user.boxCityState"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Box city and state"},domProps:{"value":(_vm.user.boxCityState)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "boxCityState", $event.target.value)}}})])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary",on:{"click":_vm.updateProfile}},[_vm._v("Update Profile")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-danger",on:{"click":_vm.logOut}},[_vm._v("Logout")])])}
var profile_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-7"},[_c('h4',{staticClass:"mt-3"},[_vm._v("Avatar Color:")])])}]
var profile_esExports = { render: profile_render, staticRenderFns: profile_staticRenderFns }
/* harmony default export */ var components_profile = (profile_esExports);
// CONCATENATED MODULE: ./src/components/profile.vue
function profile_injectStyle (ssrContext) {
  __webpack_require__("smbl")
}
var profile_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var profile___vue_template_functional__ = false
/* styles */
var profile___vue_styles__ = profile_injectStyle
/* scopeId */
var profile___vue_scopeId__ = "data-v-fb9b9b9c"
/* moduleIdentifier (server only) */
var profile___vue_module_identifier__ = null
var profile_Component = profile_normalizeComponent(
  profile,
  components_profile,
  profile___vue_template_functional__,
  profile___vue_styles__,
  profile___vue_scopeId__,
  profile___vue_module_identifier__
)

/* harmony default export */ var src_components_profile = (profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/workout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import Workout from '@/workoutData.js'

/* harmony default export */ var components_workout = ({
  name: 'workout',
  components: {
    kDialog: src_components_kDialog
  },
  data: function data() {
    return {
      workout: {
        date: "",
        workoutType: "",
        description: "",
        result: "",
        resultTieBreak: "",
        rx: false,
        pr: false,
        oneRepMax: false,
        liftType: "",
        tags: [],
        notes: "",
        isNamedWod: false,
        namedWod: ""
      },
      validClass: {
        workoutType: "valid",
        description: "valid",
        result: "valid",
        liftType: "valid"
      },
      format: format_default.a,
      updateChanges: false,
      tagString: "",
      workoutDate: "",
      formErrors: [],
      showModal: false
    };
  },

  computed: {
    workoutId: function workoutId() {
      if (this.$route.params.id != 0) {
        return this.$route.params.id;
      } else {
        return undefined;
      }
    },
    liftTypes: function liftTypes() {
      return this.$store.state.liftTypes;
    },
    namedWods: function namedWods() {
      return this.$store.state.namedWods;
    },
    workouts: function workouts() {
      return this.$store.state.workouts;
    },
    authUser: function authUser() {
      return this.$store.state.authUser;
    },
    user: function user() {
      return this.$store.state.user;
    },
    userId: function userId() {
      return this.$store.getters.userId;
    },
    db: function db() {
      return this.$store.state.db;
    },

    metconOrLift: function metconOrLift() {
      if (this.workout.workoutType == 'metcon') {
        return 'metcon';
      } else if (this.workout.workoutType == 'lift') {
        return 'lift';
      } else if (this.workout.workoutType == 'other') {
        return 'other';
      } else {
        return 'noSelection';
      }
    }
  },
  created: function created() {
    var _this = this;

    if (this.workoutId) {
      console.log("This is an existing workout... looking up data.");
      this.db.collection('users').doc(this.userId).collection('workouts').doc(this.workoutId).get().then(function (workout) {
        console.log("data found...");
        _this.workout = workout.data();
        _this.tagString = _this.workout.tags.join();
        _this.workoutDate = format_default()(_this.workout.date, 'YYYY-MM-DD');
      });
    } else {
      console.log("This is a new workout... no id.");
      this.workoutDate = format_default()(new Date(), 'YYYY-MM-DD');
    }

    this.$store.commit('setLiftTypes');
    this.$store.commit('setNamedWods');
  },

  methods: {
    setType: function setType(type) {
      this.workout.workoutType = type;
      this.updateChanges = true;
      if (type == 'other') {
        this.workout.oneRepMax = false;
        this.workout.liftType = "";
        this.workout.isNamedWod = false;
        this.workout.namedWod = "";
      }
      if (type == 'metcon') {
        this.workout.oneRepMax = false;
        this.workout.liftType = "";
      }
      if (type == 'lift') {
        this.workout.isNamedWod = false;
        this.workout.namedWod = "";
      }
    },
    changesMade: function changesMade() {
      this.updateChanges = true;
    },
    saveWorkout: function saveWorkout() {
      var _this2 = this;

      var isValid = this.formValid();

      if (isValid) {
        var workoutPayload = this.workout;
        workoutPayload.date = new Date(format_default()(this.workoutDate));
        workoutPayload.tags = this.tagString.split(",").map(function (item) {
          return item.trim();
        });

        //console.log(workoutPayload)

        this.$store.dispatch('saveNewWorkout', workoutPayload).then(function () {
          _this2.$notify({
            group: 'note',
            text: 'Wokout Added!',
            type: 'save'
          });
        });
      } else {
        var errorTxt = "";
        this.formErrors.forEach(function (err, index) {
          errorTxt += index + 1 + '. ' + err + '<br/>';
        });

        this.$notify({
          group: 'note',
          text: errorTxt,
          type: 'error'
        });
      }
    },
    commitUpdates: function commitUpdates() {
      var _this3 = this;

      var isValid = this.formValid();

      if (isValid) {
        var workoutPayload = {
          workoutId: this.workoutId,
          workout: this.workout
        };
        workoutPayload.workout.date = new Date(format_default()(this.workoutDate));
        workoutPayload.workout.tags = this.tagString.split(",").map(function (item) {
          return item.trim();
        });

        //console.log(workoutPayload['workout'])
        this.$store.dispatch('updateWorkout', workoutPayload).then(function () {
          _this3.$notify({
            group: 'note',
            text: 'Wokout Saved!',
            type: 'save'
          });
        });
      } else {
        var errorTxt = "";
        this.formErrors.forEach(function (err, index) {
          errorTxt += index + 1 + '. ' + err + '<br/>';
        });

        this.$notify({
          group: 'note',
          text: errorTxt,
          type: 'error'
        });
      }
    },
    confirmDelete: function confirmDelete() {
      this.showModal = true;
    },
    deleteWorkout: function deleteWorkout() {
      var _this4 = this;

      console.log('Delete Workout selected.');
      this.$store.dispatch('deleteWorkout', this.workoutId).then(function () {
        _this4.$notify({
          group: 'note',
          text: 'Wokout Deleted Successfully',
          type: 'save'
        });
        _this4.showModal = false;
      });
    },
    formValid: function formValid() {
      //reset all values
      this.formErrors = [];
      this.validClass.workoutType = 'valid';
      this.validClass.description = 'valid';
      this.validClass.result = 'valid';
      this.validClass.liftType = 'valid';

      if (this.workout.workoutType == "") {
        this.validClass.workoutType = "is-invalid";
        this.formErrors.push("Workout type must be either 'Metcon', 'Lift', or 'Other'.");
      }
      if (this.workout.description == "" && !this.workout.oneRepMax && !this.workout.isNamedWod) {
        this.validClass.description = "is-invalid";
        this.formErrors.push("Workout 'Description' can not be blank.");
      }
      if (this.workout.result == "") {
        this.validClass.result = "is-invalid";
        this.formErrors.push("Workout 'Result' can not be blank.");
      } else if (this.workout.oneRepMax == true) {
        //make sure result only contains digits 0-9
        var validResult = /^\d+$/.test(this.workout.result);
        if (!validResult) {
          this.validClass.result = "is-invalid";
          this.formErrors.push("'Result' can only contain numbers. As in '415' not '415 lbs' ");
        }
      } else if (this.workout.isNamedWod == true) {}
      if (this.workout.oneRepMax == true && this.workout.liftType.trim() == '') {
        this.validClass.liftType = "is-invalid";
        this.formErrors.push("If this was a 1 rep max attempt, what lift was it?");
      }

      if (this.formErrors.length == 0) {
        return true;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ee2988","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workout.vue
var workout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideRight"}},[_c('div',{staticClass:"container"},[_c('form',{staticClass:"form"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Workout Date")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workoutDate),expression:"workoutDate"}],staticClass:"form-control",attrs:{"type":"date","placeholder":"Workout Date"},domProps:{"value":(_vm.workoutDate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.workoutDate=$event.target.value},_vm.changesMade]}})]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-toggle mb-3",attrs:{"data-toggle":"buttons"}},[_c('label',{staticClass:"btn btn-outline-primary",class:[{active: _vm.metconOrLift == 'metcon'}, _vm.validClass.workoutType]},[_c('input',{attrs:{"type":"radio","name":"options","autocomplete":"off"},domProps:{"checked":_vm.metconOrLift == 'metcon'},on:{"click":function($event){$event.preventDefault();_vm.setType('metcon')}}}),_vm._v(" Metcon\n      ")]),_vm._v(" "),_c('label',{staticClass:"btn btn-outline-primary",class:[{active: _vm.metconOrLift == 'lift'}, _vm.validClass.workoutType]},[_c('input',{attrs:{"type":"radio","name":"options","autocomplete":"off"},domProps:{"checked":_vm.metconOrLift == 'lift'},on:{"click":function($event){$event.preventDefault();_vm.setType('lift')}}}),_vm._v(" Lift\n      ")]),_vm._v(" "),_c('label',{staticClass:"btn btn-outline-primary",class:[{active: _vm.metconOrLift == 'other'}, _vm.validClass.workoutType]},[_c('input',{attrs:{"type":"radio","name":"options","autocomplete":"off"},domProps:{"checked":_vm.metconOrLift == 'other'},on:{"click":function($event){$event.preventDefault();_vm.setType('other')}}}),_vm._v(" Other\n      ")])]),_vm._v(" "),_c('small',{directives:[{name:"show",rawName:"v-show",value:(_vm.validClass.workoutType == 'is-invalid'),expression:"validClass.workoutType == 'is-invalid'"}],staticClass:"mt-2 text-danger"},[_vm._v("Please Choose One")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.metconOrLift == 'lift'),expression:"metconOrLift == 'lift'"}]},[_c('toggle-button',{attrs:{"color":"#2780E3","sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"height":33,"width":68},on:{"input":_vm.changesMade},model:{value:(_vm.workout.oneRepMax),callback:function ($$v) {_vm.$set(_vm.workout, "oneRepMax", $$v)},expression:"workout.oneRepMax"}}),_vm._v(" "),_c('label',[_vm._v("Was this lift a 1 rep max attempt?")])],1),_vm._v(" "),(_vm.workout.oneRepMax)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Ok, What Lift?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.liftType),expression:"workout.liftType"}],staticClass:"form-control",class:[_vm.validClass.liftType],on:{"input":_vm.changesMade,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.workout, "liftType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Please select one")]),_vm._v(" "),_vm._l((_vm.liftTypes),function(lift){return _c('option',{key:lift.id},[_vm._v(_vm._s(lift.name))])})],2)]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.metconOrLift == 'metcon'),expression:"metconOrLift == 'metcon'"}]},[_c('toggle-button',{attrs:{"color":"#2780E3","sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"height":33,"width":68},on:{"input":_vm.changesMade},model:{value:(_vm.workout.isNamedWod),callback:function ($$v) {_vm.$set(_vm.workout, "isNamedWod", $$v)},expression:"workout.isNamedWod"}}),_vm._v(" "),_c('label',[_vm._v("Was this a 'Named' Girl, Hero, or Open Wod?")])],1),_vm._v(" "),(_vm.workout.isNamedWod)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Ok, Which Wod?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.namedWod),expression:"workout.namedWod"}],staticClass:"form-control",class:[_vm.validClass.namedWod],on:{"input":_vm.changesMade,"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.workout, "namedWod", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Please select one")]),_vm._v(" "),_vm._l((_vm.namedWods),function(wod){return _c('option',{key:wod.id,domProps:{"value":wod}},[_vm._v(_vm._s(wod.name))])})],2),_vm._v(" "),_c('label',[_vm._v("WOD Description:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.namedWod.description),expression:"workout.namedWod.description"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.workout.namedWod.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout.namedWod, "description", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(_vm.workout.oneRepMax || _vm.workout.isnamedWod)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Any additional lift description?")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.description),expression:"workout.description"}],staticClass:"form-control",attrs:{"rows":"2","placeholder":"Workout Description"},domProps:{"value":(_vm.workout.description)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "description", $event.target.value)},_vm.changesMade]}})]):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Workout Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.description),expression:"workout.description"}],staticClass:"form-control",class:[_vm.validClass.description],attrs:{"rows":"7","placeholder":"Workout Description... Hint: Go to your box's website and copy and paste your workout here."},domProps:{"value":(_vm.workout.description)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "description", $event.target.value)},_vm.changesMade]}}),_vm._v(" "),(_vm.validClass.description == 'is-invalid')?_c('small',{staticClass:"text-danger form-text"},[_vm._v("A workout must have a description!")]):_vm._e()]),_vm._v(" "),(_vm.workout.oneRepMax)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Max lifted Weight?")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.result),expression:"workout.result"}],staticClass:"form-control col-6",class:[_vm.validClass.result],staticStyle:{"display":"inline"},attrs:{"type":"text","placeholder":"e.g. 225"},domProps:{"value":(_vm.workout.result)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "result", $event.target.value)},_vm.changesMade]}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v(" lbs/kgs")])])]),_vm._v(" "),_c('small',{staticClass:"helper-text"},[_vm._v("Please enter only the exact lb or kg lifted.")])]):(_vm.workout.isNamedWod)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Result")]),_vm._v(" "),(_vm.workout.namedWod.resultMeasure == 'time or reps and tiebreak')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.result),expression:"workout.result"}],staticClass:"form-control col-5",class:[_vm.validClass.result],staticStyle:{"display":"inline"},attrs:{"type":"text","placeholder":"Time or Reps"},domProps:{"value":(_vm.workout.result)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "result", $event.target.value)},_vm.changesMade]}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.resultTieBreak),expression:"workout.resultTieBreak"}],staticClass:"form-control col-6",class:[_vm.validClass.result],staticStyle:{"display":"inline"},attrs:{"type":"text","placeholder":"Tie Break Time"},domProps:{"value":(_vm.workout.resultTieBreak)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "resultTieBreak", $event.target.value)},_vm.changesMade]}}),_vm._v(" "),_c('small',{staticClass:"helper-text"},[_vm._v(_vm._s(_vm.workout.namedWod.resultDesc))])]):_c('div',{staticClass:"input-group"},[(_vm.workout.namedWod.resultMeasure == 'time')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.result),expression:"workout.result"}],staticClass:"form-control col-6",class:[_vm.validClass.result],staticStyle:{"display":"inline"},attrs:{"type":"text","placeholder":"e.g. 4:55"},domProps:{"value":(_vm.workout.result)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "result", $event.target.value)},_vm.changesMade]}}):(_vm.workout.namedWod.resultMeasure == 'total weight')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.result),expression:"workout.result"}],staticClass:"form-control col-6",class:[_vm.validClass.result],staticStyle:{"display":"inline"},attrs:{"type":"text","placeholder":"e.g. 25"},domProps:{"value":(_vm.workout.result)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "result", $event.target.value)},_vm.changesMade]}}):(_vm.workout.namedWod.resultMeasure == 'total reps')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.result),expression:"workout.result"}],staticClass:"form-control col-6",class:[_vm.validClass.result],staticStyle:{"display":"inline"},attrs:{"type":"text","placeholder":"e.g. 25"},domProps:{"value":(_vm.workout.result)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "result", $event.target.value)},_vm.changesMade]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.result),expression:"workout.result"}],staticClass:"form-control col-6",class:[_vm.validClass.result],staticStyle:{"display":"inline"},attrs:{"type":"text","placeholder":"e.g. 6+4"},domProps:{"value":(_vm.workout.result)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "result", $event.target.value)},_vm.changesMade]}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v(" "+_vm._s(_vm.workout.namedWod.resultMeasure))])])])]):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Result")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.result),expression:"workout.result"}],staticClass:"form-control",class:[_vm.validClass.result],attrs:{"type":"text","placeholder":"5+1 or 3:45 or 245#, etc..."},domProps:{"value":(_vm.workout.result)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "result", $event.target.value)},_vm.changesMade]}}),_vm._v(" "),(_vm.validClass.result == 'is-invalid')?_c('small',{staticClass:"text-danger form-text"},[_vm._v("You must enter a result!")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.metconOrLift == 'metcon'),expression:"metconOrLift == 'metcon'"}]},[_c('toggle-button',{attrs:{"color":"#2780E3","sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"height":33,"width":68},on:{"input":_vm.changesMade},model:{value:(_vm.workout.rx),callback:function ($$v) {_vm.$set(_vm.workout, "rx", $$v)},expression:"workout.rx"}}),_vm._v(" "),_c('label',[_vm._v("Workout Performed RX?")]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('toggle-button',{attrs:{"color":"#2780E3","sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"height":33,"width":68},on:{"input":_vm.changesMade},model:{value:(_vm.workout.pr),callback:function ($$v) {_vm.$set(_vm.workout, "pr", $$v)},expression:"workout.pr"}}),_vm._v(" "),_c('label',[_vm._v("Personal Record? (PR)")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tags")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tagString),expression:"tagString"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"#Clean&Jerk, #hurt"},domProps:{"value":(_vm.tagString)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.tagString=$event.target.value},_vm.changesMade]}}),_vm._v(" "),_c('small',{staticClass:"helper-text"},[_vm._v("Tags must start with #, Have no spaces, and be seperated by commas.")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Any Additional Notes?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.notes),expression:"workout.notes"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"i.e. Unbroken DU's!, or Hurt shin on boxjumps, etc..."},domProps:{"value":(_vm.workout.notes)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "notes", $event.target.value)},_vm.changesMade]}}),_vm._v(" "),_c('small',{staticClass:"helper-text"},[_vm._v("This can be anything you want...")])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.workoutId)?_c('button',{staticClass:"btn btn-outline-primary btn-block mb-5",on:{"click":_vm.saveWorkout}},[_c('icon',{attrs:{"name":"save"}}),_vm._v(" Save Workout")],1):_vm._e(),_vm._v(" "),(_vm.workoutId)?_c('button',{staticClass:"btn btn-outline-primary btn-block mb-2",on:{"click":_vm.commitUpdates}},[_c('icon',{attrs:{"name":"save"}}),_vm._v(" Save Updates to Workout")],1):_vm._e(),_vm._v(" "),(_vm.workoutId)?_c('button',{staticClass:"btn btn-outline-danger btn-block",on:{"click":_vm.confirmDelete}},[_c('icon',{attrs:{"name":"trash"}}),_vm._v(" Delete Workout")],1):_vm._e(),_vm._v(" "),_c('kDialog',{attrs:{"showModal":_vm.showModal,"typeClass":"danger","transition":"modal"}},[_c('h1',{staticClass:"centerTitle",attrs:{"slot":"header"},slot:"header"},[_c('icon',{attrs:{"name":"hand-paper-o","scale":"3"}}),_vm._v(" Stop")],1),_vm._v(" "),_c('div',{staticClass:"centerBody",attrs:{"slot":"body"},slot:"body"},[_c('h3',[_vm._v("Are you sure you want to delete this workout?")]),_vm._v(" "),_c('h6',[_vm._v("This can't be undone.")])]),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('button',{staticClass:"btn btn-outline-light btn-lg ml-2 col-4",on:{"click":function($event){_vm.showModal = false}}},[_c('icon',{attrs:{"name":"ban"}}),_vm._v(" Cancel")],1),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-dark btn-lg col-6",on:{"click":function($event){$event.preventDefault();_vm.deleteWorkout($event)}}},[_c('icon',{attrs:{"name":"trash"}}),_vm._v(" Delete")],1)])])],1)])}
var workout_staticRenderFns = []
var workout_esExports = { render: workout_render, staticRenderFns: workout_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_workout = (workout_esExports);
// CONCATENATED MODULE: ./src/components/workout.vue
function workout_injectStyle (ssrContext) {
  __webpack_require__("9ink")
}
var workout_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var workout___vue_template_functional__ = false
/* styles */
var workout___vue_styles__ = workout_injectStyle
/* scopeId */
var workout___vue_scopeId__ = "data-v-08ee2988"
/* moduleIdentifier (server only) */
var workout___vue_module_identifier__ = null
var workout_Component = workout_normalizeComponent(
  components_workout,
  selectortype_template_index_0_src_components_workout,
  workout___vue_template_functional__,
  workout___vue_styles__,
  workout___vue_scopeId__,
  workout___vue_module_identifier__
)

/* harmony default export */ var src_components_workout = (workout_Component.exports);

// EXTERNAL MODULE: ./node_modules/date-fns/distance_in_words_to_now/index.js
var distance_in_words_to_now = __webpack_require__("vBvW");
var distance_in_words_to_now_default = /*#__PURE__*/__webpack_require__.n(distance_in_words_to_now);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/search.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import firebase from 'firebase'



//import Workout from '@/workoutData.js'

/* harmony default export */ var search = ({
  name: 'search',
  components: {},
  data: function data() {
    return {
      searchDesc: true,
      searchResult: false,
      searchTags: false,
      searchNotes: false,
      format: format_default.a,
      distanceInWordsToNow: distance_in_words_to_now_default.a,
      foundWorkouts: [],
      searchTerm: "",
      searchOptions: {
        shouldSort: true,
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        includeScore: true,
        includeMatches: true,
        maxPatternLength: 32,
        minMatchCharLength: 3,
        keys: ["description", "namedWod.name", "namedWod.description", "liftType"]
      },
      searchResults: []
    };
  },

  watch: {
    searchTerm: function searchTerm() {
      var _this = this;

      if (this.searchTerm.trim() == "") {
        this.searchResults = [];
      } else {
        var myThis = this;
        this.$search(this.searchTerm.trim(), this.allWorkouts, this.searchOptions).then(function (results) {
          _this.searchResults = [];
          results.forEach(function (result) {
            if (result.matches.length > 0) {
              var text = result.matches[0].value;
              var highlightedText = "";
              var regionsAr = result.matches[0].indices;
              var nextUnhighlightedRegionStartingIndex = 0;
              //console.log(text)
              if (!regionsAr) {
                highlightedText = text;
              } else {
                regionsAr.forEach(function (region) {
                  highlightedText += '' + text.substring(nextUnhighlightedRegionStartingIndex, region[0]) + '<span class="highlight" style="text-shadow: -3px 0px 3px yellow,3px 0px 3px yellow,6px 0px 6px yellow,-6px 0px 6px yellow;">' + text.substring(region[0], region[1] + 1) + '</span>' + '';
                  nextUnhighlightedRegionStartingIndex = region[1] + 1;
                });
                highlightedText += text.substring(nextUnhighlightedRegionStartingIndex);
              }
              //console.log(highlightedText)
              result.item.highlightedText = highlightedText;
              myThis.searchResults.push(result);
            } else {
              myThis.searchResults.push(result);
            }
          });
        });
      }
    }
  },
  computed: {
    allWorkouts: function allWorkouts() {
      return this.$store.state.allWorkouts;
    },
    totalWorkoutsLoaded: function totalWorkoutsLoaded() {
      return this.allWorkouts.length;
    },
    authUser: function authUser() {
      return this.$store.state.authUser;
    },
    user: function user() {
      return this.$store.state.user;
    },

    noWorkouts: function noWorkouts() {
      return this.searchResults.length == 0;
    }
  },
  created: function created() {
    var _this2 = this;

    this.$store.commit('setAllWorkouts');
    this.$on('resultsFound', function (results) {
      _this2.foundWorkouts = results;
    });
  },
  mounted: function mounted() {
    this.$refs.searchInput.focus();
  },

  methods: {
    goToWorkout: function goToWorkout(id) {
      //console.log(id)
      this.$router.push({ name: 'workout', params: { id: id } });
    },
    setType: function setType() {
      this.searchResults = [];
      var searchKeys = [];
      if (this.searchDesc) {
        searchKeys.push("description");
        searchKeys.push("namedWod.name");
        searchKeys.push("namedWod.description");
        searchKeys.push("liftType");
      }
      if (this.searchResult) {
        searchKeys.push("result");
      }
      if (this.searchTags) {
        searchKeys.push("tags");
      }
      if (this.searchNotes) {
        searchKeys.push("notes");
      }
      this.searchOptions.keys = searchKeys;
      this.searchTerm = "";
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f6d37b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('label',[_vm._v("Searching Within:")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('toggle-button',{attrs:{"color":"#2780E3","sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"height":20,"width":45},on:{"change":function($event){_vm.setType()}},model:{value:(_vm.searchDesc),callback:function ($$v) {_vm.searchDesc=$$v},expression:"searchDesc"}}),_vm._v(" "),_c('label',[_vm._v("Description")])],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('toggle-button',{attrs:{"color":"#2780E3","sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"height":20,"width":45},on:{"change":function($event){_vm.setType()}},model:{value:(_vm.searchResult),callback:function ($$v) {_vm.searchResult=$$v},expression:"searchResult"}}),_vm._v(" "),_c('label',[_vm._v("Result")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('toggle-button',{attrs:{"color":"#2780E3","sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"height":20,"width":45},on:{"change":function($event){_vm.setType()}},model:{value:(_vm.searchTags),callback:function ($$v) {_vm.searchTags=$$v},expression:"searchTags"}}),_vm._v(" "),_c('label',[_vm._v("Tags")])],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('toggle-button',{attrs:{"color":"#2780E3","sync":true,"labels":{checked: 'Yes', unchecked: 'No'},"height":20,"width":45},on:{"change":function($event){_vm.setType()}},model:{value:(_vm.searchNotes),callback:function ($$v) {_vm.searchNotes=$$v},expression:"searchNotes"}}),_vm._v(" "),_c('label',[_vm._v("Notes")])],1)]),_vm._v(" "),_c('div',{staticClass:"form"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],ref:"searchInput",staticClass:"form-control col-12",attrs:{"type":"text"},domProps:{"value":(_vm.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value}}})]),_vm._v(" "),(!_vm.noWorkouts)?_c('ul',{staticClass:"list-group mt-2"},_vm._l((_vm.searchResults),function(result){return (result.score < 1 && result.matches.length > 0)?_c('li',{key:result.item.id,staticClass:"list-group-item",on:{"click":function($event){$event.preventDefault();_vm.goToWorkout(result.item.id)}}},[(result.item.pr)?_c('icon',{staticClass:"text-warning",attrs:{"name":"star"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"badge badge-pill",class:[result.item.workoutType == 'metcon' ? 'badge-primary' : result.item.workoutType == 'lift' ? 'badge-secondary' :  'badge-info']},[_vm._v(_vm._s(result.item.workoutType))]),_vm._v(" \n      "+_vm._s(_vm.format(result.item.date, 'MM/DD/YYYY'))+"\n      "),(result.item.liftType)?_c('div',{staticClass:"workoutDesc"},[_vm._v("Lift: "+_vm._s(result.item.liftType)+" - "),_c('span',{domProps:{"innerHTML":_vm._s(result.item.highlightedText)}})]):(result.item.isNamedWod)?_c('div',{staticClass:"workoutDesc"},[_vm._v("\""+_vm._s(result.item.namedWod.name)+"\" - "),_c('span',{domProps:{"innerHTML":_vm._s(result.item.highlightedText)}})]):_c('div',{staticClass:"workoutDesc"},[_c('span',{domProps:{"innerHTML":_vm._s(result.item.highlightedText)}})]),_vm._v(" "),_c('div',{staticClass:"workoutResult"},[_c('strong',[_vm._v("Result:")]),_vm._v(" "+_vm._s(result.item.result)+" "),(result.item.rx)?_c('span',{staticClass:"badge badge-pill badge-dark"},[_vm._v("Rx")]):_vm._e()])],1):_vm._e()})):_vm._e(),_vm._v(" "),(_vm.noWorkouts)?_c('div',{staticClass:"card mt-2"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title",staticStyle:{"text-align":"center"}},[_c('icon',{attrs:{"name":"hand-o-up","scale":"2"}}),_vm._v(" Start Searching...")],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._v("\n     \n  ")])])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var components_search = (search_esExports);
// CONCATENATED MODULE: ./src/components/search.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("IoiM")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = "data-v-50f6d37b"
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  search,
  components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)

/* harmony default export */ var src_components_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_login = ({
  name: 'login',
  data: function data() {
    return {
      email: "",
      showEmailTxt: false,
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      saveEmail: false,
      validClass: {
        pin: 'valid',
        email: 'valid'
      }
    };
  },

  computed: {
    password: function password() {
      return '' + this.pin1 + this.pin2 + this.pin3 + this.pin4 + '-WhtBrd';
    }
  },
  created: function created() {
    var authEmail = this.$localStorage.get('authEmail', 'notSet');
    if (authEmail != 'notSet') {
      console.log('AuthEmail is set...Filling in Email');
      this.email = authEmail;
      this.saveEmail = true;
    } else {
      console.log('AuthEmail is not set');
      this.showEmailTxt = true;
    }
  },

  methods: {
    changeUser: function changeUser() {
      this.email = "";
      this.showEmailTxt = true;
    },
    pinInput: function pinInput(pin) {
      //console.log(this.$refs[`pin${pin}`].value)
      if (this.$refs['pin' + pin].value.length === 1 && pin != 4) {
        this.$refs['pin' + (pin + 1)].focus();
      }
    },
    pinDelete: function pinDelete(pin) {
      if (this.$refs['pin' + pin].value.length === 1) {
        this.$refs['pin' + pin].value = "";
      } else if (this.$refs['pin' + pin].value.length < 1 && pin != 1) {
        this.$refs['pin' + (pin - 1)].value = "";
        this.$refs['pin' + (pin - 1)].focus();
      }
    },
    isValid: function isValid() {
      //reset all values
      this.formErrors = [];
      this.validClass.email = 'valid';
      this.validClass.pin = 'valid';

      if (this.email == "") {
        this.validClass.email = "is-invalid";
        this.formErrors.push("Sorry, 'email' must ba a valid email address.");
      }
      if (this.pin1 == "" || this.pin2 == "" || this.pin3 == "" || this.pin4 == "") {
        this.pin4 = "";
        this.pin3 = "";
        this.pin2 = "";
        this.pin1 = "";
        this.validClass.pin = "is-invalid";
        this.formErrors.push("Woops, You must enter a 4 digit numeric PIN, Try again!");
      }

      if (this.formErrors.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    login: function login() {
      var _this = this;

      var isValid = this.isValid();
      if (isValid) {

        if (this.saveEmail) {
          this.$localStorage.set('authEmail', this.email);
        } else {
          this.$localStorage.remove('authEmail');
          console.log('if set AuthEmail is set ... being removed');
        }

        firebase_default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
          console.log('User Logged in successfully.');
          _this.$store.commit('setAuthUser');

          _this.$store.commit('setWorkouts');
          _this.$store.commit('setAllWorkouts');

          _this.$store.state.db.collection('users').doc(user.uid).get().then(function (doc) {
            //console.log(doc.data())
            _this.$store.commit('setUser', doc.data());

            _this.$router.replace("home");
          }).catch(function (err) {
            console.log('Woops Error get user data. Err: ' + err);
            _this.$notify({
              group: 'note',
              title: "Woops",
              text: err.message,
              type: 'error',
              duration: 4500
            });
          });
        }, function (err) {
          console.log('Woops. Err: ' + err.message);
          _this.validClass.pin = "is-invalid";
          _this.pin4 = "";
          _this.pin3 = "";
          _this.pin2 = "";
          _this.pin1 = "";
          _this.$refs['pin1'].focus();
          _this.$notify({
            group: 'note',
            text: "Sorry username or password is incorrect or not found",
            type: 'error',
            duration: 5000
          });
        });
      } else {
        var errorTxt = "";
        this.formErrors.forEach(function (err, index) {
          errorTxt += index + 1 + '. ' + err + '<br/>';
        });

        this.$notify({
          group: 'note',
          text: errorTxt,
          type: 'error'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-156e3035","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('img',{staticClass:"logo mt-2 mb-3",attrs:{"src":__webpack_require__("2YVP")}}),_vm._v(" "),_c('form',{staticClass:"form col-10 offset-1"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEmailTxt),expression:"showEmailTxt"}]},[_c('h4',{staticClass:"text-center"},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control mt-2",class:[_vm.validClass.email],attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"custom-control custom-checkbox mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.saveEmail),expression:"saveEmail"}],staticClass:"custom-control-input",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.saveEmail)?_vm._i(_vm.saveEmail,null)>-1:(_vm.saveEmail)},on:{"change":function($event){var $$a=_vm.saveEmail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.saveEmail=$$a.concat([$$v]))}else{$$i>-1&&(_vm.saveEmail=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.saveEmail=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"custom-control-indicator"}),_vm._v(" "),_c('span',{staticClass:"custom-control-description"},[_vm._v("Save Email?")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showEmailTxt),expression:"!showEmailTxt"}],staticClass:"text-center mb-4"},[_vm._v("\n          Email: "+_vm._s(_vm.email)+" "),_c('span',{staticClass:"text-primary"},[_c('a',{on:{"click":_vm.changeUser}},[_vm._v("not you?")])])]),_vm._v(" "),_c('h3',{staticClass:"text-center"},[_vm._v("Enter PIN")]),_vm._v(" "),_c('div',{staticClass:"pin-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin1),expression:"pin1"}],ref:"pin1",staticClass:"form-control pinbox",class:[_vm.validClass.pin],attrs:{"type":"number","min":"0","inputmode":"numeric","pattern":"[0-9]*","maxlength":"1"},domProps:{"value":(_vm.pin1)},on:{"keyup":[function($event){_vm.pinInput(1)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.pinDelete(1)}],"input":function($event){if($event.target.composing){ return; }_vm.pin1=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin2),expression:"pin2"}],ref:"pin2",staticClass:"form-control pinbox ml-1 mr-1",class:[_vm.validClass.pin],attrs:{"type":"number","min":"0","inputmode":"numeric","pattern":"[0-9]*","maxlength":"1"},domProps:{"value":(_vm.pin2)},on:{"keyup":[function($event){_vm.pinInput(2)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.pinDelete(2)}],"input":function($event){if($event.target.composing){ return; }_vm.pin2=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin3),expression:"pin3"}],ref:"pin3",staticClass:"form-control pinbox mr-1",class:[_vm.validClass.pin],attrs:{"type":"number","min":"0","inputmode":"numeric","pattern":"[0-9]*","maxlength":"1"},domProps:{"value":(_vm.pin3)},on:{"keyup":[function($event){_vm.pinInput(3)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.pinDelete(3)}],"input":function($event){if($event.target.composing){ return; }_vm.pin3=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin4),expression:"pin4"}],ref:"pin4",staticClass:"form-control pinbox",class:[_vm.validClass.pin],attrs:{"type":"number","min":"0","inputmode":"numeric","pattern":"[0-9]*","maxlength":"1"},domProps:{"value":(_vm.pin4)},on:{"keyup":[function($event){_vm.pinInput(4)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }_vm.pinDelete(4)}],"input":function($event){if($event.target.composing){ return; }_vm.pin4=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary mt-4 btn-lg col-8 offset-2",on:{"click":function($event){$event.preventDefault();_vm.login($event)}}},[_vm._v("Login")]),_vm._v(" "),(_vm.showEmailTxt)?_c('p',{staticClass:"text-center mt-2"},[_vm._v("No Account? "),_c('router-link',{attrs:{"to":"/signup"}},[_vm._v("Sign Up!")])],1):_vm._e()])])])}
var login_staticRenderFns = []
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_login = (login_esExports);
// CONCATENATED MODULE: ./src/components/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("gG8J")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-156e3035"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  components_login,
  selectortype_template_index_0_src_components_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_components_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/signup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_signup = ({
  name: 'login',
  data: function data() {
    return {
      db: "",
      email: "",
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      name: "",
      boxName: "",
      boxCityState: "",
      validClass: {
        pin: "valid",
        name: "valid",
        email: "valid"
      },
      formErrors: []
    };
  },
  created: function created() {
    //this.db = firebase.firestore()
  },

  computed: {
    password: function password() {
      return '' + this.pin1 + this.pin2 + this.pin3 + this.pin4 + '-WhtBrd';
    }
  },
  methods: {
    pinInput: function pinInput(pin) {
      //console.log(this.$refs[`pin${pin}`].value)
      if (this.$refs['pin' + pin].value.length === 1 && pin != 4) {
        this.$refs['pin' + (pin + 1)].focus();
      }
    },
    isValid: function isValid() {
      //reset all values
      this.formErrors = [];
      this.validClass.name = 'valid';
      this.validClass.email = 'valid';
      this.validClass.pin = 'valid';

      if (this.name == "") {
        this.validClass.name = "is-invalid";
        this.formErrors.push("Don't be silly...the 'Name' field can not be blank.");
      }
      if (this.email == "") {
        this.validClass.email = "is-invalid";
        this.formErrors.push("Sorry, 'email' must ba a valid email address.");
      }
      if (this.pin1 == "" || this.pin2 == "" || this.pin3 == "" || this.pin4 == "") {
        this.pin4 = "";
        this.pin3 = "";
        this.pin2 = "";
        this.pin1 = "";
        this.validClass.pin = "is-invalid";
        this.formErrors.push("Woops, You must enter a 4 digit numeric PIN, Try again!");
      }

      if (this.formErrors.length == 0) {
        return true;
      } else {
        return false;
      }
    },
    signup: function signup() {
      var _this = this;

      var isValid = this.isValid();

      if (isValid) {

        firebase_default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (user) {
          _this.$store.state.db.doc('users/' + user.uid).set({
            displayName: _this.name,
            email: _this.email,
            boxName: _this.boxName,
            boxCityState: _this.boxCityState,
            bgColor: ""
          }).then(function () {
            console.log('User creaated successfully. Added to Firestore!. Redirecting to home...');
            _this.$store.commit('setAuthUser');
            _this.$store.state.db.collection('users').doc(user.uid).get().then(function (doc) {
              _this.$store.commit('setUser', doc.data());
              _this.$notify({ group: 'note', text: 'Sign up successful!', type: 'signUp-success' });
              _this.$router.replace("home");
            });
          });
        }, function (err) {
          //alert(`Woops: ${err.message}`)
          _this.$notify({ group: 'note', title: "Woops", text: err.message, type: 'error', duration: 4500 });
          console.log('Woops: ' + err.message);
        });
      } else {
        var errorTxt = "";
        this.formErrors.forEach(function (err, index) {
          errorTxt += index + 1 + '. ' + err + '<br/>';
        });

        this.$notify({
          group: 'note',
          text: errorTxt,
          type: 'error'
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad47de06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/signup.vue
var signup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('img',{staticClass:"logo mt-1 mb-4",attrs:{"src":__webpack_require__("2YVP")}}),_vm._v(" "),_c('form',{staticClass:"form col-10 offset-1"},[_c('h3',{staticClass:"center"},[_vm._v("Sign Up")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control mt-2",class:[_vm.validClass.name],attrs:{"type":"text","placeholder":"Name i.e. 'Darth Vader'"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control mt-2",class:[_vm.validClass.email],attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"mt-2"},[_vm._v("Choose a 4 digit PIN")]),_vm._v(" "),_c('div',{staticClass:"pin-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin1),expression:"pin1"}],ref:"pin1",staticClass:"form-control pinbox",class:[_vm.validClass.pin],attrs:{"type":"text","maxlength":"1"},domProps:{"value":(_vm.pin1)},on:{"keyup":function($event){_vm.pinInput(1)},"input":function($event){if($event.target.composing){ return; }_vm.pin1=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin2),expression:"pin2"}],ref:"pin2",staticClass:"form-control pinbox ml-1 mr-1",class:[_vm.validClass.pin],attrs:{"type":"text","maxlength":"1"},domProps:{"value":(_vm.pin2)},on:{"keyup":function($event){_vm.pinInput(2)},"input":function($event){if($event.target.composing){ return; }_vm.pin2=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin3),expression:"pin3"}],ref:"pin3",staticClass:"form-control pinbox mr-1",class:[_vm.validClass.pin],attrs:{"type":"text","maxlength":"1"},domProps:{"value":(_vm.pin3)},on:{"keyup":function($event){_vm.pinInput(3)},"input":function($event){if($event.target.composing){ return; }_vm.pin3=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pin4),expression:"pin4"}],ref:"pin4",staticClass:"form-control pinbox",class:[_vm.validClass.pin],attrs:{"type":"text","maxlength":"1"},domProps:{"value":(_vm.pin4)},on:{"keyup":function($event){_vm.pinInput(4)},"input":function($event){if($event.target.composing){ return; }_vm.pin4=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v("Optional")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.boxName),expression:"boxName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Box Name"},domProps:{"value":(_vm.boxName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.boxName=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.boxCityState),expression:"boxCityState"}],staticClass:"form-control mt-2",attrs:{"type":"text","placeholder":"Box City and State"},domProps:{"value":(_vm.boxCityState)},on:{"input":function($event){if($event.target.composing){ return; }_vm.boxCityState=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary btn-block mt-2",on:{"click":function($event){$event.preventDefault();_vm.signup($event)}}},[_vm._v("Sign Up")]),_vm._v(" "),_c('p',{staticClass:"center mt-2"},[_vm._v("Go back to "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1)])])])}
var signup_staticRenderFns = []
var signup_esExports = { render: signup_render, staticRenderFns: signup_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_signup = (signup_esExports);
// CONCATENATED MODULE: ./src/components/signup.vue
function signup_injectStyle (ssrContext) {
  __webpack_require__("RUa/")
}
var signup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var signup___vue_template_functional__ = false
/* styles */
var signup___vue_styles__ = signup_injectStyle
/* scopeId */
var signup___vue_scopeId__ = "data-v-ad47de06"
/* moduleIdentifier (server only) */
var signup___vue_module_identifier__ = null
var signup_Component = signup_normalizeComponent(
  components_signup,
  selectortype_template_index_0_src_components_signup,
  signup___vue_template_functional__,
  signup___vue_styles__,
  signup___vue_scopeId__,
  signup___vue_module_identifier__
)

/* harmony default export */ var src_components_signup = (signup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var admin = ({
  name: 'admin',
  components: {
    Toolbar: src_components_toolbar
  },
  data: function data() {
    return {
      msg: 'This is the admin page.. Add Hero, girl wods, Add Lifts, reset passwords,  etc...',
      editWod: false,
      workout: {
        name: "",
        catagory: "",
        description: "",
        resultMeasure: "",
        resultDesc: ""
      }
    };
  },

  computed: {
    namedWods: function namedWods() {
      return this.$store.state.namedWods;
    }
  },
  created: function created() {
    this.$store.commit('setNamedWods');
  },

  methods: {
    submitWorkout: function submitWorkout() {
      var _this = this;

      var wodPayload = this.workout;

      this.$store.dispatch('addWod', wodPayload).then(function () {
        _this.$notify({
          group: 'note',
          text: 'New Wod Added!',
          type: 'save'
        });
        //reset form...
        _this.workout = {
          name: "",
          catagory: "",
          description: "",
          resultMeasure: "",
          resultDesc: ""
        };
      }).catch(function (err) {
        console.log('Woops: ' + err);
      });
    },
    loadWod: function loadWod(wodId) {
      this.workout = this.namedWods.find(function (wod) {
        return wod.id == wodId;
      });
      this.editWod = true;
    },
    resetForm: function resetForm() {
      this.editWod = false;
      this.workout = {
        id: null,
        name: "",
        catagory: "",
        description: "",
        resultMeasure: "",
        resultDesc: ""
      };
      delete this.workout.id;
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9357b122","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin.vue
var admin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',[_vm._v("Add Named Wod/Hero Wod/Open Wod")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Wod Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.name),expression:"workout.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"eg. 'DT' or Open 'Wod 15.2'"},domProps:{"value":(_vm.workout.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"catagory"}},[_vm._v("Wod Catagory")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.catagory),expression:"workout.catagory"}],staticClass:"form-control",attrs:{"id":"catagory"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.workout, "catagory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',[_vm._v("Crossfit Open")]),_vm._v(" "),_c('option',[_vm._v("Hero")]),_vm._v(" "),_c('option',[_vm._v("girls")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"description"}},[_vm._v("Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.description),expression:"workout.description"}],staticClass:"form-control",attrs:{"type":"text","id":"description","rows":"5"},domProps:{"value":(_vm.workout.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"resultMeasure"}},[_vm._v("Result Measure")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.resultMeasure),expression:"workout.resultMeasure"}],staticClass:"form-control",attrs:{"id":"resultMeasure"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.workout, "resultMeasure", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',[_vm._v("max weight lifted")]),_vm._v(" "),_c('option',[_vm._v("rounds and reps")]),_vm._v(" "),_c('option',[_vm._v("time")]),_vm._v(" "),_c('option',[_vm._v("time or reps and tiebreak")]),_vm._v(" "),_c('option',[_vm._v("total reps")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"resultDesc"}},[_vm._v("Result Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.workout.resultDesc),expression:"workout.resultDesc"}],staticClass:"form-control",attrs:{"type":"text","id":"resultDesc","rows":"3"},domProps:{"value":(_vm.workout.resultDesc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workout, "resultDesc", $event.target.value)}}})]),_vm._v(" "),(!_vm.editWod)?_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){$event.preventDefault();_vm.submitWorkout($event)}}},[_vm._v("Save WOD")]):_vm._e(),_vm._v(" "),(_vm.editWod)?_c('button',{staticClass:"btn btn-outline-success",on:{"click":function($event){$event.preventDefault();_vm.updateWorkout($event)}}},[_vm._v("Update WOD")]):_vm._e(),_vm._v(" "),(_vm.editWod)?_c('button',{staticClass:"btn btn-outline-danger",on:{"click":function($event){$event.preventDefault();_vm.updateWorkout($event)}}},[_vm._v("Delete WOD")]):_vm._e(),_vm._v(" "),(_vm.editWod)?_c('button',{staticClass:"btn btn-outline-warning",on:{"click":function($event){$event.preventDefault();_vm.resetForm($event)}}},[_vm._v("Reset Form")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Edit Existing Wod")]),_vm._v(" "),_vm._l((_vm.namedWods),function(wod){return _c('button',{key:wod.id,staticClass:"btn btn-outline-info ml-1 mb-1",on:{"click":function($event){_vm.loadWod(wod.id)}}},[_vm._v(_vm._s(wod.name)+" - "+_vm._s(wod.catagory.slice(0,1)))])})],2)}
var admin_staticRenderFns = []
var admin_esExports = { render: admin_render, staticRenderFns: admin_staticRenderFns }
/* harmony default export */ var components_admin = (admin_esExports);
// CONCATENATED MODULE: ./src/components/admin.vue
function admin_injectStyle (ssrContext) {
  __webpack_require__("aE1q")
}
var admin_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var admin___vue_template_functional__ = false
/* styles */
var admin___vue_styles__ = admin_injectStyle
/* scopeId */
var admin___vue_scopeId__ = "data-v-9357b122"
/* moduleIdentifier (server only) */
var admin___vue_module_identifier__ = null
var admin_Component = admin_normalizeComponent(
  admin,
  components_admin,
  admin___vue_template_functional__,
  admin___vue_styles__,
  admin___vue_scopeId__,
  admin___vue_module_identifier__
)

/* harmony default export */ var src_components_admin = (admin_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js





/*import WorkoutAdd from '@/components/workoutAdd' */





vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '*',
    redirect: '/login'
  }, {
    path: '/',
    redirect: '/login'
  }, {
    path: '/home',
    name: 'home',
    component: src_components_home,
    meta: {
      requiresAuth: true,
      showBack: false,
      showCalendar: true
    }
  }, {
    path: '/workout/:id',
    name: 'workout',
    component: src_components_workout,
    meta: {
      requiresAuth: true,
      showBack: true
    }
  }, {
    path: '/profile',
    name: 'profile',
    component: src_components_profile,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/search',
    name: 'search',
    component: src_components_search,
    meta: {
      requiresAuth: true,
      showBack: true
    }
  }, {
    path: '/login',
    name: 'login',
    component: src_components_login,
    meta: {
      showToolbar: false
    }
  }, {
    path: '/signup',
    name: 'signup',
    component: src_components_signup,
    meta: {
      showToolbar: false
    }
  }, {
    path: '/admin',
    name: 'admin',
    component: src_components_admin,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      showBack: true,
      showCalendar: false
    }
  }]
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/config/firebaseConfig.js
var config = {
  apiKey: "AIzaSyDz7C8jSe3NaVkTqbPemO5FMuHeofV-ePc",
  authDomain: "whtbrd-c459a.firebaseapp.com",
  databaseURL: "https://whtbrd-c459a.firebaseio.com",
  projectId: "whtbrd-c459a",
  storageBucket: "whtbrd-c459a.appspot.com",
  messagingSenderId: "358692504306"
};
// EXTERNAL MODULE: ./node_modules/date-fns/is_this_month/index.js
var is_this_month = __webpack_require__("cONr");
var is_this_month_default = /*#__PURE__*/__webpack_require__.n(is_this_month);

// CONCATENATED MODULE: ./src/liftTypes.js
/* harmony default export */ var liftTypes = ({
    lifts: [{
        'id': 1,
        'name': 'Front Squat'
    }, {
        'id': 2,
        'name': 'Back Squat'
    }, {
        'id': 3,
        'name': 'Over Head Squat'
    }, {
        'id': 4,
        'name': 'Power Clean'
    }, {
        'id': 5,
        'name': 'Squat Clean'
    }, {
        'id': 6,
        'name': 'Clean & Jerk'
    }, {
        'id': 7,
        'name': 'Push Jerk'
    }, {
        'id': 8,
        'name': 'Split Jerk'
    }, {
        'id': 9,
        'name': 'Strict Press'
    }, {
        'id': 10,
        'name': 'Push Press'
    }, {
        'id': 11,
        'name': 'Bench Press'
    }, {
        'id': 12,
        'name': 'Dead Lift'
    }, {
        'id': 13,
        'name': 'Power Snatch'
    }, {
        'id': 14,
        'name': 'Squat Snatch'
    }]
});
// CONCATENATED MODULE: ./src/store/index.js










//import NamedWods from '@/wods-named.js'

firebase_default.a.initializeApp(config);

vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    user: {},
    authUser: {},
    workouts: [], //these only the last 30 workouts
    allWorkouts: [],
    db: firebase_default.a.firestore(),
    liftTypes: [],
    namedWods: []
  },
  getters: {
    userId: function userId(state) {
      return state.authUser.uid;
    },
    score: function score(state) {
      var rxWorkouts = 0;
      var scaledWorkouts = 0;
      state.workouts.forEach(function (workout) {
        if (workout.rx) {
          rxWorkouts += 2;
        } else {
          scaledWorkouts += 1;
        }
      });
      return rxWorkouts + scaledWorkouts;
    },
    scoreThisMonth: function scoreThisMonth(state) {
      var rxWorkouts = 0;
      var scaledWorkouts = 0;
      var thisMonthWorkouts = state.workouts.filter(function (workout) {
        return is_this_month_default()(workout.date);
      });
      thisMonthWorkouts.forEach(function (workout) {
        if (workout.rx) {
          rxWorkouts += 2;
        } else {
          scaledWorkouts += 1;
        }
      });
      return rxWorkouts + scaledWorkouts;
    },
    workoutsThisMonth: function workoutsThisMonth(state) {
      var thisMonthWorkouts = state.workouts.filter(function (workout) {
        return is_this_month_default()(workout.date);
      });
      return thisMonthWorkouts.length;
    },
    totalWorkouts: function totalWorkouts(state) {
      return state.allWorkouts.length;
    },
    workoutDates: function workoutDates(state) {
      var dates = state.allWorkouts.map(function (workout) {
        var desc = "";
        if (workout.isNamedWod) {
          desc = workout.namedWod.name;
        } else {
          desc = workout.description;
        }
        return { 'date': workout.date, 'type': workout.workoutType, 'id': workout.id, 'desc': desc };
      });
      return dates;
    }
  },
  mutations: {
    setUser: function setUser(state, user) {
      state.user = user;
    },
    setAuthUser: function setAuthUser(state) {
      state.authUser = firebase_default.a.auth().currentUser;
    },
    setWorkouts: function setWorkouts(state) {
      var workoutsCollection = state.db.collection('users').doc(state.authUser.uid).collection('workouts');
      workoutsCollection.orderBy('date', 'desc').limit(30).get().then(function (querySnapshot) {
        var workouts = [];
        querySnapshot.forEach(function (doc) {
          var thisWorkout = doc.data();
          thisWorkout['id'] = doc.id;
          workouts.push(thisWorkout);
        });
        state.workouts = workouts;
      }).catch(function (err) {
        console.log('Error getting workouts. Err: ' + err);
      });
    },
    setAllWorkouts: function setAllWorkouts(state) {
      var workoutsCollection = state.db.collection('users').doc(state.authUser.uid).collection('workouts');
      workoutsCollection.orderBy('date', 'desc').get().then(function (querySnapshot) {
        var workouts = [];
        querySnapshot.forEach(function (doc) {
          var thisWorkout = doc.data();
          thisWorkout['id'] = doc.id;
          workouts.push(thisWorkout);
        });
        state.allWorkouts = workouts;
      }).catch(function (err) {
        console.log('Error getting all workouts. Err: ' + err);
      });
    },
    setBgColor: function setBgColor(state, color) {
      state.user.bgColor = color;
    },
    updateUser: function updateUser(state) {
      //console.log(state.user)
      state.db.collection('users').doc(state.authUser.uid).set(state.user).then(function () {
        console.log("User successfully written!");
      }).catch(function (error) {
        console.error("Error writing document: ", error);
      });
    },
    resetStore: function resetStore(state) {
      state.user = {}, state.authUser = {}, state.workouts = [];
    },
    setLiftTypes: function setLiftTypes(state) {
      //this sorts the lift alphabetically by 'name' key
      var importedLifts = liftTypes.lifts.sort(function (a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();

        var comparison = 0;
        if (nameA > nameB) {
          comparison = 1;
        } else if (nameA < nameB) {
          comparison = -1;
        }
        return comparison;
      });
      this.state.liftTypes = importedLifts;
    },
    setNamedWods: function setNamedWods(state) {
      var namedWodsCollection = state.db.collection('namedWods');
      namedWodsCollection.orderBy('name', 'asc').get().then(function (querySnapshot) {
        var returnedWods = [];
        var counter = 0;
        querySnapshot.forEach(function (doc) {
          var thisWod = doc.data();
          thisWod['id'] = doc.id;
          returnedWods.push(thisWod);
          counter++;
          if (counter == querySnapshot.size) {
            //console.log("counter equals number of docs")
            state.namedWods = returnedWods;
          }
        });
        //console.log(querySnapshot)
      });
    }
    /*
    uploadNamedWorkouts: function (state) {
      let counter = 0
      let namedWodsCollection = state.db.collection('namedWods')
      state.namedWods.forEach(wod => {
        namedWodsCollection.add(wod)
        .then(wod => {
          counter++
          if(counter == state.namedWods.length){
            console.log(`${counter} wods uploaded.`)
          }
        })
        .catch(err => {
          console.log(`Err: ${err}`)
        })
      })
      
    }*/

  }, //End Mutations
  actions: {
    ///Admin Actions ///
    addWod: function addWod(_ref, wodPayload) {
      var commit = _ref.commit,
          state = _ref.state;

      var namedWodsCollection = state.db.collection('namedWods');

      return new promise_default.a(function (resolve, reject) {
        namedWodsCollection.add(wodPayload).then(function (wod) {
          console.log('Wod Added with Id: ' + wod.id);
          commit('setNamedWods');
        }).catch(function (err) {
          console.log('Woops: ' + err);
        });
        resolve();
      });
    },

    ///--- END Admin Actions ///
    saveNewWorkout: function saveNewWorkout(_ref2, workoutPayload) {
      var commit = _ref2.commit,
          state = _ref2.state;

      var workoutCollection = state.db.collection('users').doc(state.authUser.uid).collection('workouts');

      return new promise_default.a(function (resolve, reject) {
        workoutCollection.add(workoutPayload).then(function (workout) {
          console.log('Workout Added with Id: ' + workout.id);
          commit('setWorkouts');
          router.push({ path: '/home' });
          commit('setAllWorkouts');
        }).catch(function (err) {
          console.log('Woops: ' + err);
        });
        resolve();
      });
    },
    deleteWorkout: function deleteWorkout(_ref3, workoutId) {
      var commit = _ref3.commit,
          state = _ref3.state;

      console.log('workoutid to delete is: ' + workoutId);
      var workoutCollection = state.db.collection('users').doc(state.authUser.uid).collection('workouts');

      return new promise_default.a(function (resolve, reject) {
        workoutCollection.doc(workoutId).delete().then(function () {
          console.log('Workout Deleted');
          commit('setWorkouts');
          router.push({ path: '/home' });
          commit('setAllWorkouts');
        }).catch(function (err) {
          alert('Woops... Something went wrong.');
          console.log('Error: ' + err);
        });
        resolve();
      });
    },
    updateWorkout: function updateWorkout(_ref4, workoutPayload) {
      var commit = _ref4.commit,
          state = _ref4.state;

      var id = workoutPayload.workoutId;
      var workout = workoutPayload.workout;

      if (!workout.pr) {
        workout.pr = false;
      }
      if (!workout.rx) {
        workout.rx = false;
      }
      if (!workout.oneRepMax) {
        workout.oneRepMax = false;
      }

      return new promise_default.a(function (resolve, reject) {
        state.db.collection('users').doc(state.authUser.uid).collection('workouts').doc(id).set(workout).then(function () {
          console.log('Workout ' + id + ' updated Successfully.');
          commit('setWorkouts');
          router.go(-1);
          commit('setAllWorkouts');
        }).catch(function (err) {
          console.log('Woops error updateing workout. Err: ' + err);
        });
        resolve();
      });
    }
  } // End Actions
}));
// EXTERNAL MODULE: ./node_modules/vue-fuse/index.js
var vue_fuse = __webpack_require__("XTKK");

// EXTERNAL MODULE: ./node_modules/vue-notification/dist/index.js
var dist = __webpack_require__("CLX7");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-localstorage/dist/vue-local-storage.js
var vue_local_storage = __webpack_require__("UnSZ");
var vue_local_storage_default = /*#__PURE__*/__webpack_require__.n(vue_local_storage);

// EXTERNAL MODULE: ./node_modules/vue-awesome/icons/index.js + 786 modules
var icons = __webpack_require__("D/PP");

// EXTERNAL MODULE: ./node_modules/vue-awesome/components/Icon.vue + 2 modules
var Icon = __webpack_require__("D4uH");

// EXTERNAL MODULE: ./node_modules/v-calendar/lib/v-calendar.min.js
var v_calendar_min = __webpack_require__("sY/S");
var v_calendar_min_default = /*#__PURE__*/__webpack_require__.n(v_calendar_min);

// EXTERNAL MODULE: ./node_modules/v-calendar/lib/v-calendar.min.css
var lib_v_calendar_min = __webpack_require__("xWv6");
var lib_v_calendar_min_default = /*#__PURE__*/__webpack_require__.n(lib_v_calendar_min);

// EXTERNAL MODULE: ./node_modules/vue2-animate/dist/vue2-animate.min.css
var vue2_animate_min = __webpack_require__("6A3X");
var vue2_animate_min_default = /*#__PURE__*/__webpack_require__.n(vue2_animate_min);

// EXTERNAL MODULE: ./node_modules/vue-js-toggle-button/dist/index.js
var vue_js_toggle_button_dist = __webpack_require__("nkUn");
var vue_js_toggle_button_dist_default = /*#__PURE__*/__webpack_require__.n(vue_js_toggle_button_dist);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





vue_esm["default"].use(vue_fuse["a" /* default */]);

vue_esm["default"].use(dist_default.a);


vue_esm["default"].use(vue_local_storage_default.a);

//fontAwesome 4


vue_esm["default"].component('icon', Icon["a" /* default */]);

//v-calendar


// Use v-calendar, v-date-picker & v-popover components
vue_esm["default"].use(v_calendar_min_default.a);

//vue2-animate //https://github.com/asika32764/vue2-animate 





vue_esm["default"].use(vue_js_toggle_button_dist_default.a);

vue_esm["default"].prototype.$appVer = '1.2.5';

router.beforeEach(function (to, from, next) {
  //console.log(to)
  window.scrollTo(0, 0);

  var currentUser = firebase_default.a.auth().currentUser;
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });
  var requiresAdmin = to.matched.some(function (record) {
    return record.meta.requiresAdmin;
  });

  if (requiresAuth) {
    if (!currentUser) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      //check to see if user is admin
      if (requiresAdmin) {
        console.log('This route requires Admin');
        console.log(store.state.user);
        if (store.state.user) {
          console.log('This user is Admin');
          next();
        } else {
          console.log('This user is NOT Admin... redirect to login');
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          });
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

vue_esm["default"].config.productionTip = false;

firebase_default.a.auth().onAuthStateChanged(function (user) {
  console.log('Firebase OnAuthStateChange fired!');
  if (!user) {
    console.log('No user... routing to login');
    router.replace('/home');
  }
});

var app = new vue_esm["default"]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  created: function created() {},
  data: function data() {
    return {
      appName: 'whtBrd',
      appVer: this.$appVer
    };
  },

  components: { App: src_App }
});

/***/ }),

/***/ "RUa/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TAvA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UkAe":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "aE1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cGVt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gG8J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "smbl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wK/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
var fuse = __webpack_require__("BDm9");
var fuse_default = /*#__PURE__*/__webpack_require__.n(fuse);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-fuse/src/VueFuse.vue



window.Fuse = fuse_default.a;

/* harmony default export */ var VueFuse = ({
  data: function data() {
    return {
      fuse: null,
      search: '',
      result: []
    };
  },

  props: {
    eventName: {
      type: String,
      default: 'fuseResultsUpdated'
    },
    inputChangeEventName: {
      type: String,
      default: 'fuseInputChanged'
    },
    defaultAll: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    includeScore: {
      type: Boolean,
      default: false
    },
    includeMatches: {
      type: Boolean,
      default: false
    },
    tokenize: {
      type: Boolean,
      default: false
    },
    matchAllTokens: {
      type: Boolean,
      default: false
    },
    findAllMatches: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    shouldSort: {
      type: Boolean,
      default: true
    },
    threshold: {
      type: Number,
      default: 0.6
    },
    location: {
      type: Number,
      default: 0
    },
    distance: {
      type: Number,
      default: 100
    },
    maxPatternLength: {
      type: Number,
      default: 32
    },
    minMatchCharLength: {
      type: Number,
      default: 1
    },
    keys: {
      type: Array
    }
  },
  computed: {
    options: function options() {
      var options = {
        caseSensitive: this.caseSensitive,
        includeScore: this.includeScore,
        includeMatches: this.includeMatches,
        tokenize: this.tokenize,
        matchAllTokens: this.matchAllTokens,
        findAllMatches: this.findAllMatches,
        shouldSort: this.shouldSort,
        threshold: this.threshold,
        location: this.location,
        distance: this.distance,
        maxPatternLength: this.maxPatternLength,
        minMatchCharLength: this.minMatchCharLength,
        keys: this.keys
      };
      if (this.id !== '') {
        options.id = this.id;
      }
      return options;
    }
  },
  watch: {
    search: function search() {

      this.$parent.$emit(this.inputChangeEventName, this.search);

      if (this.search.trim() === '') {
        if (this.defaultAll) {
          this.result = this.list;
        } else {
          this.result = [];
        }
      } else this.result = this.fuse.search(this.search.trim());
    },
    result: function result() {
      this.$parent.$emit(this.eventName, this.result);
    }
  },
  methods: {
    initFuse: function initFuse() {
      this.fuse = new window.Fuse(this.list, this.options);
      if (this.defaultAll) {
        this.result = this.list;
      }
    }
  },
  ready: function ready() {
    this.initFuse();
  },
  mounted: function mounted() {
    this.initFuse();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71fc4dc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-fuse/src/VueFuse.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"search"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_VueFuse = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-fuse/src/VueFuse.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  VueFuse,
  src_VueFuse,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_fuse_src_VueFuse = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xWv6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.fb90b20dca720a515f92.js